import { formatDate, BaseTransaction, formatBalance, Currency } from '@ui/src';
import { PaymentType } from '../types';

import cn from '../styles.module.css';

const formatIncomingList = ({
  list,
  currenciesList,
  paymentTypes,
}: {
  list: BaseTransaction[];
  currenciesList?: Currency[];
  paymentTypes?: PaymentType[];
}): BaseTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const currentCurrency = currenciesList?.find(
      (currency) => currency.id === result.currencyId,
    );

    const currentPaymentType = paymentTypes?.find(
      (type) => type.paymentType === item.paymentType,
    );

    const render: Record<string, any> = {
      transferDate: <div>{formatDate(result?.transferDate || '', true)}</div>,
      currencyId: <div>{result?.currency?.name || ''}</div>,
      recipientAccountNumber: result?.recipientAccount ? (
        <div className={cn.beneficiaryContent}>
          <div className={cn.beneficiaryName}>
            {result?.recipientAccount?.description}
          </div>
          <div className={cn.beneficiaryFullNumber}>
            {result?.recipientAccount?.fullNumber}
          </div>
        </div>
      ) : (
        result.recipientAccountNumber
      ),
      paymentType: <div>{currentPaymentType?.name}</div>,
      sum: <div>{formatBalance(result.sum, currentCurrency)}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatIncomingList;
